/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.top[_ngcontent-%COMP%]{\n    margin-top: 1.5rem;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvY2FuY2VsLXJlYXNvbi1wb3B1cC9jYW5jZWwtcmVhc29uLXBvcHVwLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL2Jvb2tpbmctbWFuYWdlbWVudC9jYW5jZWwtcmVhc29uLXBvcHVwL2NhbmNlbC1yZWFzb24tcG9wdXAuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/cancel-reason-popup/cancel-reason-popup.component.css.shim.ngstyle.ts